import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { TargetingSettingsContext } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import adScheduleColumnTemplate from './target.pug';

export class ColumnAdSchedule extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    const localizedTitle = i18n.getString('ColumnName_AdSchedule');

    super({
      name: 'AdSchedule',
      type: 'string',
      property: ['Id', 'CampaignCriterions'],
      sortable: false,
      title: 'ColumnName_AdSchedule',
      helpId: 'pop_BA_CampaignsGrid_AdSchedule',
      i18n,
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: localizedTitle }),
    });

    this.i18n = i18n;
  }

  template({ value }) {
    const cid = TargetingSettingsContext.state.get('customer_id');
    const aid = TargetingSettingsContext.state.get('account_id');
    const link = `#customer/${cid}/account/${aid}/campaign/${value.cmpid}/edit`;
    return adScheduleColumnTemplate({ link, name: value.adSchduleName });
  }

  get property() {
    return {
      get: ({ Id, CampaignCriterions }) => {
        let name;
        const adSchedules = _.filter(CampaignCriterions, criterion => criterion.Criterion.Type === 'DayTime');
        if (!adSchedules || adSchedules.length === 0) {
          name = this.i18n.getString('Grid_AdSchedule_Default');
        } else {
          const bids = _.chain(adSchedules).pluck('CriterionBid').pluck('Multiplier').value();
          name = _.some(bids, b => b > 0) ? this.i18n.getString('Grid_AdSchedule_Custom_Bid') : this.i18n.getString('Grid_AdSchedule_Custom');
        }

        return {
          cmpid: Id,
          adSchduleName: name,
        };
      },
      key: this.config.property,
    };
  }
}
